import { Check } from "lucide-react";

const InsightAndRules = () => {
  return (
    <div className="flex flex-col flex-1 min-h-0 py-5 gap-3.5">
      <div className="border rounded-md">
        <div className="flex items-center justify-between bg-slate-50 p-4">
          <div className="flex flex-col">
            <span className="font-bold text-light-black text-xss tracking-widest uppercase">
              matching rule
            </span>
            <span className="font-semibold text-md text-black">
              Set the priority-review threshold
            </span>
            <span className="font-medium text-xss text-light-black">
              Preview how many applicants will appear under Priority Applicants
              before saving a change.
            </span>
          </div>
          <div className="flex items-center border rounded-md">
            <div className="flex flex-col px-3 py-1.5 w-28">
              <span className="uppercase font-bold text-xsss text-light-black">
                saved rule
              </span>
              <span className="font-semibold text-md">75%</span>
            </div>
            <div className="flex flex-col px-3 py-1.5 w-28 border-l">
              <span className="uppercase font-bold text-xsss text-light-black">
                preview
              </span>
              <span className="font-semibold text-md">75%</span>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-4">
        <div className="border rounded-md p-4 flex-1">
          <div className="flex flex-col">
            <span className="font-bold text-light-black text-xss tracking-widest uppercase">
              Applicant distribution
            </span>
            <span className="font-semibold text-md text-black">
              Where the 59 match scores sit
            </span>
            <span className="font-medium text-xsss text-light-black">
              See the available review volume across each score band.
            </span>
          </div>
        </div>
        <div className="border rounded-md p-4 flex-1">
          <div className="flex flex-col">
            <span className="font-bold text-light-black text-xss tracking-widest uppercase">
              Evidence patterns
            </span>
            <span className="font-semibold text-md text-black">
              Most common gaps against the role
            </span>
            <span className="font-medium text-xsss text-light-black">
              Use these patterns to understand the pool—not to make automatic
              decisions.
            </span>
          </div>
        </div>
      </div>

      <div className="flex items-center border border-l-[4px] border-l-slate-600 rounded-md p-4 gap-3">
        <div className="flex items-center justify-center w-8 h-8 rounded-full border border-light-grey shrink-0">
          <Check size={14} />
        </div>
        <div className="flex flex-col">
          <span className="font-bold text-light-black text-xsss tracking-widest uppercase">
            Decision safeguard
          </span>
          <span className="font-semibold text-sm text-black mt-1">
            The Agent remains in control
          </span>
          <span className="font-medium text-xss text-light-black">
            Matching organises the review queue; it does not make a recruitment
            decision. Every below-threshold candidate remains retrievable and no
            status or message changes without an Agent action.{" "}
          </span>
        </div>
      </div>
    </div>
  );
};

export default InsightAndRules;
